import { useQuery } from '@tanstack/react-query';
import { consentTemplatesApiQueryKeys } from '@/features/dashboard/consentTemplates/api/consentTemplatesApi.queryKeys.ts';
import consentTemplatesApi from '@/features/dashboard/consentTemplates/api/consentTemplatesApi.ts';

const useGetConsentTemplateVariables = () => {
  return useQuery({
    queryKey: consentTemplatesApiQueryKeys.variables(),
    queryFn: () => consentTemplatesApi.getVariables(),
  });
};

export default useGetConsentTemplateVariables;
